export const generateOutput = (inputData, inputSelectedItems) => {
    const output = {};
    if (!inputData || !Array.isArray(inputData)) return output;

    const selectedItemsSet = inputSelectedItems instanceof Set ? inputSelectedItems : new Set(inputSelectedItems);

    inputData.forEach(block => {
      if (!block || !block.id) return;

      const blockId = block.id.toString();
      const sectionOutput = {};
      let allBlockRowsSelected = true;
      let hasAnySelection = false;

      if (block.children && Array.isArray(block.children)) {
        block.children.forEach(section => {
          if (!section || !section.name) return;

          const sectionId = section.name.toString();
          const allRowKeys = section.children?.map(row => `row-${row.tracker_row_id}`) || [];
          const selectedRowKeys = allRowKeys.filter(key => selectedItemsSet.has(key));

          if (selectedRowKeys.length === allRowKeys.length && allRowKeys.length > 0) {
            sectionOutput[sectionId] = -1;
            hasAnySelection = true;
          } else if (selectedRowKeys.length > 0) {
            sectionOutput[sectionId] = section.children
              ?.filter(row => selectedItemsSet.has(`row-${row.tracker_row_id}`))
              .map(row => row.tracker_row_id) || [];
            hasAnySelection = true;
            allBlockRowsSelected = false;
          } else {
            allBlockRowsSelected = false;
          }
        });
      }

      if (hasAnySelection) {
        output[blockId] = allBlockRowsSelected ? -1 : sectionOutput;
      }
    });

    return output;
  };